import { useState } from "react";
import UniversityService from "../services/UniversityService";
import { useQuery } from "@tanstack/react-query";
import SectionContainer from "./SectionContainer";
import { Col, Container, Row } from "reactstrap";
import BreadCrumb from "../component/BreadCrumb/BreadCrumb"
import { imageBaseApi } from "../services/imageBaseApi";
import arrow from "../assets/kangaroo/arrow-cropped.svg";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Professional = ({ slug }) => {
  const [selectedItem, setSelectedItem] = useState(false)
  const [selectedItem2, setSelectedItem2] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [visibleCount, setVisibleCount] = useState(
    window.innerWidth < 768 ? 8 : 24
  );

  const fetchData = async () => {
    const response = await UniversityService.getList()
    return response
  }

  const { isPending, error, data: universityData } = useQuery({
    queryKey: ["university"],
    queryFn: fetchData
  })

  const handleLoadMore = () => {
    if (visibleCount >= universityData?.length) {
      setVisibleCount(24);
    } else {
      // const newCount = visibleCount + 15;
      setVisibleCount(universityData?.length || 0);
    }
  };







  return (
    <>

      <Container fluid className="p-0">


        <Row>
          <Col>
            <h1 className='font-level-4 mb-5'>INSTITUTIONS WE REPRESENT</h1>
          </Col>
        </Row>

        {/* Search Filters */}


        {/* University Grid */}
        <Row className="gy-4 ">
          {universityData
            ?.filter((item) =>
              slug ? item?.slug !== slug : true
            )
            ?.slice(0, visibleCount)
            ?.map((item, index) => (
              <Col
                xl={3}
                lg={4}
                md={6}
                sm={6}
                xs={12}
                key={item?.slug || index}
                className="p-2 d-flex justify-content-lg-between justify-content-center"
              >
                <Link to={`/institution/${item?.slug}`}>
                  <motion.div
                    className="d-flex justify-content-center border rounded align-items-center"
                    style={{
                      height: "126px",
                      width: "100%",
                      maxWidth: "235px",
                    }}
                    whileHover={{ scale: 1.15 }}
                    transition={{
                      duration: 0.3,
                      ease: "easeInOut"
                    }}
                  >
                    <img
                      src={imageBaseApi + item?.logoMedia?.url}
                      alt={item?.name || "University logo"}
                      style={{ objectFit: "contain", height: "100%", width: "100%" }}
                      className="rounded"
                    />
                  </motion.div>
                </Link>
              </Col>
            ))}
        </Row>


        {/* Load More Button */}
        {universityData?.length > 24 && (<Row className='mt-5'>
          <Col className='d-flex flex-column justify-content-center align-items-center' style={{ cursor: "pointer" }} onClick={handleLoadMore}>
            <h1 className='button-font-Ins text-center mb-3'>
              {visibleCount >= universityData?.length ? "LOAD LESS INSTITUTION" : "LOAD MORE INSTITUTION"}
            </h1>
            <img
              src={arrow}
              className={visibleCount >= universityData?.length ? "rotate-180" : "rotate-90"}
              alt="Load more arrow"
              style={{ maxWidth: "50px" }}
            />
          </Col>
        </Row>)}
      </Container>


    </>
  )
}

export default Professional